export const detailFields = [
  { id: 'label', label: 'Card name', placeholder: 'Professional', maxLength: 50 },
  { id: 'name', label: 'Full name', placeholder: 'Your name', maxLength: 100 },
  { id: 'title', label: 'Job title', placeholder: 'What you do', maxLength: 100 },
  { id: 'company', label: 'Company', placeholder: 'Where you work', maxLength: 100 },
  { id: 'location', label: 'Location', placeholder: 'Your city or region', maxLength: 100 },
  { id: 'bio', label: 'About you', placeholder: 'A little about you…', maxLength: 400 },
] as const;
export type DetailField = typeof detailFields[number]['id'];

// Retain private values in the editor, but remove them from presentation and sharing.
export function visibleCardDetails<T extends { hiddenDetails?: readonly DetailField[] }>(card: T): T {
  const visible = { ...card };
  for (const key of card.hiddenDetails || []) if (key !== 'label') Object.assign(visible, { [key]: '' });
  return visible;
}
